// src/data/featuredTools.ts

export interface Tool {
  icon: string;
  title: string;
  description: string;
  longDescription: string;
  toolUrl: string;
  isFree?: boolean;
  tags?: string[];
}

export const featuredTools: Tool[] = [
  {
    "title": "CustomGPT.ai",
    "description": "Custom-trained AI chatbot builder for your business, docs, or website.",
    "longDescription": "<div class='text-base text-gray-700'>CustomGPT.ai lets you train ChatGPT on your own data—such as PDFs, websites, or private files—to create smart, brand-aligned AI assistants. Perfect for customer support, internal knowledge bases, or any personalized AI use case without coding.</div>",
    // "toolUrl": "https://www.customgpt.ai",
    "toolUrl":"https://customgpt.ai/?fpr=chirag38",
    "icon": "🤖",
    "isFree": false,
    "tags": ["custom chatbot", "GPT-powered", "no-code AI", "business AI"]
  }

];
